import * as Yup from 'yup';
import * as message from '../../../constant/message';

export const stateSchema = Yup.object().shape({
  name: Yup.string().required(message.ZONE_REQUIRED),
  cityId: Yup.string().required(message.CITY_REQUIRED),
  description: Yup.string().required(message.DESCRIPTION_REQUIRED),
});
